import './TokiPona.scss'

export default function SitelenQuiz() {
    return (
        <div id="tokipona-quiz">
            <div className='centered-container'>
                <h1>Sitelen Pona Quiz</h1>
                <p>Not implemented yet!</p>
            </div>
        </div>
    );
}